<div class="chips_cont_inner">
	<ng-container *ngFor="let singleFilterControls of controls.singleFilterControls; let i = index">
		<button *ngIf="singleFilterControls.options" class="{{singleFilterControls.name==='Instock'?'instock':''}}" >
			{{singleFilterControls.name}}
		</button>
	</ng-container>

	<ng-container *ngFor="let nestedSegment of controls.nestedControls; let i = index">
		<ng-container *ngFor="let subCat of nestedSegment.options; let l = index">
			<button *ngIf="subCat.activated">
				{{subCat.name}}
			</button>
		</ng-container>
	</ng-container>

	<ng-container *ngFor="let normalFilterControl of controls.normalFilterControls; let i = index">
		<ng-container *ngFor="let normalFilterItems of normalFilterControl.options; let l = index">
			<button *ngIf="normalFilterItems.activated">
				{{normalFilterItems.name}}
			</button>
		</ng-container>
	</ng-container>

	<ng-container *ngFor="let colorFilterControls of controls.colorFilterControls[0].options; let i = index">
		<button *ngIf="colorFilterControls.activated">
			{{colorFilterControls.name}}
		</button>
	</ng-container>

	<ng-container *ngFor="let rangeFilterControls of controls.rangeFilterControls; let i = index">
		<button *ngIf="rangeFilterControls.values.defaultMin < rangeFilterControls.values.value1 && rangeFilterControls.values.value1">
			{{rangeFilterControls.name}} min - {{rangeFilterControls.values.value1}}
		</button>

		<button *ngIf="rangeFilterControls.values.defaultMax > rangeFilterControls.values.value2">
			{{rangeFilterControls.name}} max - {{rangeFilterControls.values.value2}}
		</button>

	</ng-container>

	<button (click)="clearAllFilterOption()" class="clear_allof_chips" *ngIf="clearButtonShow">
		clear
		<span class="material-symbols-outlined">
			close
		</span>
	</button>
</div>
